<form [formGroup]="parentForm">
  <mat-form-field
    color="accent"
    class="unset w-100 currency-select no-label"
  >
    <mat-select
      [formControlName]="controlName"
      data-cy="basic-job-job-type-select"
    >
      <mat-select-trigger>
        <div
          class="currency-flag currency-flag-{{getSelectedValueCode() | lowercase }}"
        ></div>
      </mat-select-trigger>
      <mat-option
        *ngFor="let item of items"
        [value]="item.code"
      >
        <div class="currency-flag currency-flag-{{item.code | lowercase }}">
        </div>
        &nbsp;{{ item.code }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
